import { GET_APPLICATION_MENU  } from '../constants';
import { handleActions } from "redux-actions"

export const menuItems  = handleActions(
  {
    [ GET_APPLICATION_MENU ]: (state, action) => {
      return { ...state, info: action.payload }
  }
}, {}
)